import React, {useState} from 'react';
import {Form, useDataProvider, useNotify, useRefresh, useTranslate} from 'react-admin';
import {useFormContext} from 'react-hook-form';
import {Box} from '@mui/material';
import PrimaryButton from '../components/statamic/PrimaryButton';
import SectionCard from '../components/statamic/SectionCard';
import ToggleRow from '../components/statamic/ToggleRow';

/**
 * The umbrella's three notification switches (OUTCOME item 10). The super-admin edit form holds
 * them as inputs; the umbrella admin edits only this card, saved through
 * PUT /api/v2/umbrellad/umbrellas/{id}/notifications.
 */
export const UmbrellaNotificationToggles = () => {
    const translate = useTranslate();
    return (
        <>
            <ToggleRow
                source="send_new_post_mail"
                label={translate('New-post e-mail')}
                subtitle={translate('Send email when new posts are created')}
                defaultValue={true}
            />
            <ToggleRow
                source="require_post_approval"
                label={translate('Post approval required')}
                subtitle={translate('Posts need approval before publication')}
                defaultValue={false}
            />
            <ToggleRow
                source="send_registration_copy_to_projects"
                label={translate('Send registration notice to projects')}
                subtitle={translate('Each project with its own email gets a short notice (first name, country, child) of every new sponsor')}
                defaultValue={false}
            />
        </>
    );
};

const SaveButton = ({saving}) => {
    const translate = useTranslate();
    const {formState: {isDirty}} = useFormContext();
    return (
        <PrimaryButton variant="primary" type="submit" disabled={saving || !isDirty}>
            {translate('Save changes')}
        </PrimaryButton>
    );
};

const UmbrellaNotificationsCard = ({record}) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const [saving, setSaving] = useState(false);

    const save = (data) => {
        setSaving(true);
        return dataProvider.updateNotifications('umbrellas', {id: record.id, data})
            .then(() => {
                notify('ra.notification.updated', {type: 'info', messageArgs: {smart_count: 1}});
                refresh();
            })
            .catch((error) => notify(error?.message || 'ra.notification.http_error', {type: 'error'}))
            .finally(() => setSaving(false));
    };

    return (
        <Form record={record} onSubmit={save}>
            <SectionCard title={translate('Notifications')} actions={<SaveButton saving={saving}/>}>
                <Box>
                    <UmbrellaNotificationToggles/>
                </Box>
            </SectionCard>
        </Form>
    );
};

export default UmbrellaNotificationsCard;
